var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-bar",class:_vm.notificationTypeClass},[_c('v-alert',_vm._b({},'v-alert',{ type: _vm.notification.type },false),[_vm._v(" "+_vm._s(_vm.notification.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }